var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',[_c('img',{attrs:{"src":_vm.item.image,"alt":_vm.item.title}})]),_c('div',[_c('h4',{domProps:{"textContent":_vm._s(_vm.item.title)}}),_c('p',{domProps:{"textContent":_vm._s(_vm.item.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }